import { render, staticRenderFns } from "./BTableCollectorCriteria.vue?vue&type=template&id=bc080c8c&"
import script from "./BTableCollectorCriteria.vue?vue&type=script&lang=js&"
export * from "./BTableCollectorCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports